<template>
  <section>
    <div class="pay-resource"
      :data-price="courseData.price">
      <div class="pay-course-info">
        <div><img :src="courseData.showImage"></div>
        <div>{{ courseData.title }}</div>
      </div>
    </div>
    <div class="pay-method">
      <ul class="pay-method-list">
        <li data-type="10"
          class="active">资源券</li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PayTicket',
  props: {
    courseData: {
      type: Object,
      default: () => { return {} }
    }
  }
}
</script>
